export const fetchpagedata = async (
  pageindex,
  id,
  isAdmin,
  selectedId,
  setDataLoading,
  setsearch,
  axiosInstance,
  requesterId,
  uuid,
  formDate,
  toDate,
  finalSelectedStatus,
  finalSelectedtxnCat,
  settable,
  setPaginationDetails,
  setIsDataLoaded,
  e,
  toast
) => {
  setDataLoading(true);
  setsearch("");
  const response = await axiosInstance
    .post(
      `/api/v1/aeps/order/history`,
      {
        header: {
          "client-id": id, // client id will admin id
          role: "ROLE_RETAILER_FINXPAY",
          msgType: "ORDER_HISTORY",
          channel: "ADMIN",
          requesterId: requesterId,
          requestId: uuid(),
          time: new Date(),
        },
        device: null,
        agentId: isAdmin ? selectedId : id,
        pageNo: pageindex,
        startDate: formDate,
        endDate: toDate,
        status:
          finalSelectedStatus !== undefined && finalSelectedStatus.length !== 0
            ? finalSelectedStatus
            : null,
        txnCategory:
          finalSelectedtxnCat !== undefined && finalSelectedtxnCat.length !== 0
            ? finalSelectedtxnCat
            : null,
      },
      {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      }
    )
    .then((res) => {
      //console.log('res', res)
      settable(res.data.orders);
      //return res
      setDataLoading(false);
      setPaginationDetails((prev) => {
        return {
          ...prev,
          totalPost: res.data?.totalElements,
          totalPages: res.data?.totalPages,
        };
      });
      setIsDataLoaded(true);
    })
    .catch((err) => {
      //console.log(err);
      setDataLoading(false);
      setIsDataLoaded(false);
      toast.error("Something went wrong");
    });

  if (response) {
    const result = response.data.orders;

    if (result) {
    }

    return response.data;
  }
  return false;
};

export const fetchreport = async (
    pageindex,
    id,
    isAdmin,
    selectedId,
    setDataLoading,
    setsearch,
    axiosInstance,
    requesterId,
    uuid,
    formDate,
    toDate,
    finalSelectedStatus,
    finalSelectedtxnCat,
    settable,
    setPaginationDetails,
    setIsDataLoaded,
    e,
    toast,
    FileSaver
) => {
  setDataLoading(true);
  const response = await axiosInstance
    .post(
      `/api/v1/aeps/order/report`,
      {
        header: {
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
          msgType: "ORDER_HISTORY",
          channel: "ADMIN",
          requesterId: requesterId,
          time: new Date(),
        },
        device: null,
        agentId: isAdmin ? selectedId : id,
        pageNo: pageindex,
        startDate: formDate,
        endDate: toDate,
        status:
          finalSelectedStatus !== undefined && finalSelectedStatus.length !== 0
            ? finalSelectedStatus
            : null,
        txnCategory:
          finalSelectedtxnCat !== undefined && finalSelectedtxnCat.length !== 0
            ? finalSelectedtxnCat
            : null,
      },
      {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      }
    )
    .then((response) => {
      const blob = new Blob([response?.data], {
          type: "text/csv;charset=utf-8;",
        }),
        url = window.URL.createObjectURL(blob);
      FileSaver.saveAs(url, "aepsdata.csv");
      setDataLoading(false);
    })
    .catch((err) => {
      //console.log(err);
      toast.error("Something went wrong");
      setDataLoading(false);
    });

  if (response) {
    const result = response.data.orders;

    if (result) {
    }

    return response.data;
  }
  return false;
};
